import { ref } from 'vue'
class LanguageClass {
  constructor() {

    this.language = ref("en")
  }

  set_language(lang) {
    this.language.value = lang
  }
  get_language() { return this.language.value }

}
export let language_util = new LanguageClass();
